import {
  CANDIDATES_INITIAL_STATE,
  FETCH_CANDIDATE_APPLICATIONS,
  FETCH_CANDIDATE_PROFILE,
} from "./candidatesConstants";
import { SIGN_OUT_USER } from "../auth/authConstants";

export default function candidatesReducer(
  state = CANDIDATES_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_CANDIDATE_PROFILE:
      return {
        ...state,
        candidateProfile: payload,
      };
    case FETCH_CANDIDATE_APPLICATIONS:
      return {
        ...state,
        applications: payload,
      };
    case SIGN_OUT_USER:
      return CANDIDATES_INITIAL_STATE;
    default:
      return state;
  }
}
